// Auto-generated file
//
// Regenerated by hand for this project — `npm run generate:screenLoader`'s
// entry-point guard compares `import.meta.url` (file:///C:/...) against
// `process.argv[1]` (a native Windows path), which never match on Windows,
// so the script silently no-ops. This file only lists the screens actually
// scaffolded here — keep it in step with src/screens/ BY HAND, and with the
// auth0_prompt_screen_renderer resources in infra/terraform/auth0.tf. A screen
// present in one and missing from the other is the "screen is not implemented"
// / blank-screen failure, and neither lint nor `npm run build` catches it.

import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  "signup-id": lazy(() => import("@/screens/signup-id")),
  "signup-password": lazy(() => import("@/screens/signup-password")),
  "email-identifier-challenge": lazy(
    () => import("@/screens/email-identifier-challenge")
  ),
  // Renders nothing — auto-declines the signup-time passkey offer. See the
  // screen's own file for why it exists. Note this is passkey-enrollment,
  // NOT passkey-enrollment-local: the latter serves progressive enrolment
  // after login and is deliberately left in standard mode.
  "passkey-enrollment": lazy(() => import("@/screens/passkey-enrollment")),
  // Step-up MFA (and ordinary login MFA) for the Flow B portal only — the
  // client filter that scopes it lives on the Terraform renderer, not here.
  // This bundle is served to every client; Auth0 simply never asks for this
  // screen unless the request matched the filter.
  "mfa-otp-challenge": lazy(() => import("@/screens/mfa-otp-challenge")),
  // Password reset: like-for-like replicas of the hosted screens, TENANT-WIDE
  // (RO-A activation and every ordinary reset). reset-password-request,
  // reset-password-email, reset-password-error and the reset-password-mfa-*
  // screens are deliberately NOT here; they stay standard. See the comment on
  // auth0_prompt_screen_renderer.reset_password in infra/terraform/auth0.tf.
  // Beneficiary Claims ONLY. Both renderers carry a filter on client metadata
  // beneficiary_app = "true" (infra/terraform/beneficiary.tf); every member
  // client gets the standard hosted screens, so these must never be made
  // tenant-wide. The beneficiary sign-up form lives inside signup-id (shared).
  "login-id": lazy(() => import("@/screens/login-id")),
  "login-passwordless-email-code": lazy(
    () => import("@/screens/login-passwordless-email-code")
  ),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-success": lazy(
    () => import("@/screens/reset-password-success")
  ),
};

export const getScreenComponent = (
  screenName: string | undefined
): React.ComponentType | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
